import { createSelector } from "reselect";

import { IStore } from "@work/redux/reducers";

const getNavigationStateFunction = (store: IStore) => store.navigation;

export const getNavigationState = createSelector(
  [getNavigationStateFunction],
  f => f,
);
